@defer (when isConfirmModalOpened) {
  <sd-modal-default
    [(isOpened)]="isConfirmModalOpened"
    [brand]="brand"
    [noPadding]="true"
    [modalTitleLevel]="4"
    [modalTitle]="
      !!messageForfait
        ? ('cart.modal.compatibilityCart.forfait.title' | translate)
        : ('cart.modal.compatibilityCart.title' | translate)
    "
  >
    <div sd-modal-body>
      @if (!!messageForfait) {
        <div>
          <p>{{ messageForfait | translate }}</p>
        </div>
      } @else {
        <div>
          <p>
            {{ (isPFS ? 'cart.modal.compatibilityCart.bodyPFS' : 'cart.modal.compatibilityCart.bodyAccessory') | translate }}
          </p>
          <br />
          <p>{{ 'cart.modal.compatibilityCart.solutionsTitle' | translate }}</p>
          <ul sd-list>
            <li>
              {{ (isPFS ? 'cart.modal.compatibilityCart.solution1PFS' : 'cart.modal.compatibilityCart.solution1Accessory') | translate }}
              <span> {{ (isPFS ? 'cart.modal.compatibilityCart.promotionCode' : '') | translate }}</span>
            </li>
            <li>{{ 'cart.modal.compatibilityCart.solution2' | translate }}</li>
          </ul>
          <br />
          <p>{{ 'cart.modal.compatibilityCart.explication' | translate }}</p>
          <p class="has-icon">
            <sd-icon name="icon-brand-xs" aria-hidden="true" [size]="iconSize.xs" />
            {{ 'cart.modal.compatibilityCart.moulinexShop' | translate }}
          </p>
          <p class="has-icon">
            <sd-icon name="icon-seller-accessories" aria-hidden="true" [size]="iconSize.xs" />
            {{ 'cart.modal.compatibilityCart.moulinexAccessory' | translate }}
          </p>
        </div>
      }
      <footer class="c__modal-actions" sd-modal-footer>
        @if (!messageForfait) {
          <a sd-button (click)="continue()" [isSecondary]="true">
            {{ 'cart.modal.compatibilityCart.continue' | translate }}
          </a>
        }
        @if (!messageForfait) {
          <button sd-button (click)="createNewCart()">
            <span>{{ 'cart.modal.compatibilityCart.changeCart' | translate }}</span>
          </button>
        }
        @if (!!messageForfait) {
          <button sd-button (click)="goToCart()">
            <span>{{ 'cart.modal.compatibilityCart.forfait.backToCart' | translate }}</span>
          </button>
        }
      </footer>
    </div>
  </sd-modal-default>
}
